// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-agent-traveler-search-traveler-profile-list-module__tableContainer--ESTUJ {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/js/agent/traveler/search/traveler-profile-list.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".tableContainer {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `src-js-agent-traveler-search-traveler-profile-list-module__tableContainer--ESTUJ`
};
export default ___CSS_LOADER_EXPORT___;
